"use client";

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

type Props = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	planName: string;
	hostedServiceCount: number;
};

export default function PlanHostingDowngradeBlockedDialog({
	open,
	onOpenChange,
	planName,
	hostedServiceCount,
}: Props) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				className="border border-[color:var(--glass-border)] bg-[var(--glass-background)] text-white shadow-[var(--glass-shadow)] backdrop-blur-xl [-webkit-backdrop-filter:var(--glass-backdrop-filter)] [backdrop-filter:var(--glass-backdrop-filter)] dark:border-[color:var(--glass-border)] dark:bg-[rgba(11,21,27,0.72)] sm:max-w-lg sm:rounded-2xl"
				closeClassName="text-white opacity-90 hover:opacity-100"
			>
				<DialogHeader>
					<DialogTitle className="text-white">Cannot downgrade hosting</DialogTitle>
					<DialogDescription className="text-white/90">
						You have {hostedServiceCount} hosted service
						{hostedServiceCount === 1 ? "" : "s"} that still require hosting.{" "}
						<span className="font-semibold text-white">{planName}</span> cannot cover
						that many websites. Contact support team for more information.
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button onClick={() => onOpenChange(false)}>OK</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
